import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
} from 'react';
import styled from 'styled-components';
import TextCounter from '../conventionFields/TextCounter';

const StyledInput = styled.input`
    width: 100%;
    height: 25px;
    padding-left: 4px;
    font-size: inherit;
    line-height: inherit;
    color: inherit;
    border: none;

    &:focus {
      outline: none;
    }
`;

export default forwardRef((props, ref) => {
  const [valueObject, setValueObject] = useState(() => props.value || { value: '' });
  const [editing, setEditing] = useState(true);
  const refInput = useRef(null);

  const width = `${props.column.getActualWidth()}px`;
  const height = `${props.rowHeight}px`;

  const { textValidator } = props.column.getColDef();

  useEffect(() => {
    setTimeout(() => refInput.current.focus());
  }, []);

  // TODO: This is common with other editors
  useEffect(() => {
    if (!editing) {
      props.api.stopEditing();
    }
  }, [editing]);

  const onChangeHandler = (e) => {
    const value = textValidator.validate(e.target.value) || '';
    const newValueObject = { value };
    setValueObject(newValueObject);

    // AG Grid v32: Call onValueChange to notify grid of value changes
    if (props.onValueChange) {
      props.onValueChange(newValueObject);
    }
  };

  const handleOnBlur = () => {
    setEditing(false);
  };

  const currentValue = valueObject.value || '';

  return (
    <div className='input-group text-cell-container' style={{ width, height }} >
      <StyledInput type="text"
        ref={refInput}
        value={currentValue}
        onChange={onChangeHandler}
        onBlur={handleOnBlur}
      />
      <span className="input-group-addon no-border-radius p-5 no-border text-size-small">
        <TextCounter maxCount={props.textLimit} currentValue={currentValue} />
      </span>
    </div>
  );
});
